import sdl from '@jds/react-generated-sdl/JDSAvatarV2CompleteRing';
import type { JDSAvatarV2CompleteRingProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSAvatarV2CompleteRingProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'medium',
    disabled = false,
    ariaLabel = 'Avatar with Activity Ring',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, disabled, ariaLabel, ...rest },
    'JDSAvatarV2CompleteRing',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const AvatarV2CompleteRing = withLogic(
  Component
) as React.FC<JDSAvatarV2CompleteRingProps> & { slotName?: string };

AvatarV2CompleteRing.displayName = 'AvatarV2CompleteRing';
AvatarV2CompleteRing.slotName = 'jds_avatar_v_2_complete_ring';

export { AvatarV2CompleteRing, type JDSAvatarV2CompleteRingProps };
